import React, { useState } from 'react';
import Button from '../button';
import Checkbox from '../form/checkbox';

import { useGlobalState } from '../../state';
import { ShelfItem } from './shelves-list-modal';

import styles from '../../styles/components/shelves-modals.module.scss';
import { Shelf } from 'types';
import TitleCopySelector from './title-copy-selector';

export default function PreferenceModal({
  onSave,
  setPreference,
  shelves,
}: {
  onSave: any;
  setPreference?: boolean;
  shelves?: Shelf[];
}) {
  const { state } = useGlobalState();
  const { shelves: shelvesData } = state;
  const { preference } = shelvesData.data;

  const [checked, setChecked] = useState(true);
  const [pinned, setPinned] = useState(preference?.pinned_copy || false);
  const [selectedShelfId, setSelectedShelfId] = useState<string>(
    preference?.shelf || null
  );
  const [selectedShelfTitle, setSelectedShelfTitle] = useState<string>(
    preference?.shelf_title || null
  );

  return (
    <div>
      <TitleCopySelector
        pinned={pinned}
        setPinned={setPinned}
      />
      {!setPreference && (
        <div className={styles['preference-checkbox']}>
          <Checkbox
            text='Save my preferences for next time'
            onPress={() => setChecked(!checked)}
            checked={checked}
          />
        </div>
      )}
      <div>
        {Boolean(shelves?.length) &&
          shelves.map((shelf: Shelf) => {
            return (
              <div key={shelf.id}>
                <ShelfItem
                  key={shelf.id}
                  id={shelf.id}
                  title={shelf.title}
                  isShelfPublic={shelf.public}
                  photo_path={
                    shelf?.selected_listings
                      ? shelf?.selected_listings[0]?.photo_path
                      : null
                  }
                  checked={selectedShelfId === shelf.id}
                  onCheck={() => {
                    if (selectedShelfId === shelf.id) {
                      setSelectedShelfId('');
                      setSelectedShelfTitle('');
                    } else {
                      setSelectedShelfId(shelf.id);
                      setSelectedShelfTitle(shelf.title);
                    }
                  }}
                  fadeUnselected={selectedShelfId !== ''}
                />
              </div>
            );
          })}
      </div>
      <Button
        text='Save'
        onPress={() =>
          onSave({
            pinned_copy: pinned,
            save_preference: checked,
            shelf_id: selectedShelfId,
            shelf_title: selectedShelfTitle,
          })
        }
        disabled={!selectedShelfId}
      />
    </div>
  );
}
